import { SocialOverTimeEnrichedRowCompare } from "app/components/React/SocialOvertime/SocialOverTimeEnrichedRowCompare";
import { SocialOverTimeEnrichedRowSingle } from "app/components/React/SocialOvertime/SocialOverTimeEnrichedRowSingle";

import { connect } from "react-redux";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";

const SocialOverTimeEnrichedRowInner = (props) => {
    const clickOutsideXButton = (e) => {
        allTrackers.trackEvent("Open", "Click", "Traffic Over Time/Collapsed");
        document.body.click();
    };
    const keys = props.params.key.split(",");
    const enrichProps = { clickOutsideXButton, keys };

    const durationRaw = DurationService.getDurationData(props.params.duration).raw;
    const { from, to } = durationRaw;
    const duration = DurationService.getDiffSymbol(from, to);
    const showTrafficOverTimeChartNoData = ["28d", "1m"].includes(duration);

    // keys.length === 1 => single mode
    return keys.length === 1 ? (
        <SocialOverTimeEnrichedRowSingle
            {...props}
            enrichProps={enrichProps}
            showTrafficOverTimeChartNoData={showTrafficOverTimeChartNoData}
        />
    ) : (
        <SocialOverTimeEnrichedRowCompare
            {...props}
            enrichProps={enrichProps}
            showTrafficOverTimeChartNoData={showTrafficOverTimeChartNoData}
        />
    );
};

const mapStateToProps = (props) => ({
    params: props.routing.params,
    chosenItems: props.routing.chosenItems,
});

const SocialOverTimeEnrichedRow = connect(mapStateToProps)(SocialOverTimeEnrichedRowInner);

// save page and pageSize as closure and return a function that got props and return JSX Element
export const GetSocialOverTimeEnrichedRow = ({ page, pageSize }) =>
    function (props) {
        return (
            <SocialOverTimeEnrichedRow
                page={page}
                pageSize={pageSize}
                {...props}
            />
        );
    };
